var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13.99 13.99" }, props),
    React.createElement(
      "title",
      null,
      "error"
    ),
    React.createElement("path", { d: "M7 14a7 7 0 1 0-7-7 7 7 0 0 0 7 7", fill: "#e07b9a" }),
    React.createElement("path", { d: "M7 10.88a.43.43 0 0 0 .43-.43.43.43 0 0 0-.86 0 .43.43 0 0 0 .43.43", fill: "#fff" }),
    React.createElement("circle", { cx: "7", cy: "10.44", r: ".43", fill: "none", stroke: "#fff", strokeMiterlimit: "10", strokeWidth: ".5" }),
    React.createElement("path", { d: "M7 3.13a.42.42 0 0 1 .43.42v4.52a.43.43 0 0 1-.86 0V3.54A.42.42 0 0 1 7 3.12", fill: "#fff" }),
    React.createElement("path", { d: "M7 3.13a.42.42 0 0 1 .43.42v4.52a.43.43 0 0 1-.86 0V3.54A.42.42 0 0 1 7 3.13z", fill: "none", stroke: "#fff", strokeMiterlimit: "10", strokeWidth: ".5" })
  );
});